module.exports = __webpack_public_path__ + "static/media/xsiriesCert.355ebb09.png";